import axios from "axios";
import { rotateRefreshToken } from "./refreshTokens";

/**
 * Registers a global Axios response interceptor: on access-token expiry,
 * rotates tokens via the same helper as the auth layer, then retries the request.
 */
let interceptorInstalled = false;

export function setupAxiosAuthInterceptor() {
  if (interceptorInstalled) {
    return;
  }
  interceptorInstalled = true;

  axios.interceptors.request.use((config) => {
    const url = config.url || "";
    if (url.includes("/refresh")) {
      return config;
    }
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const status = error.response?.status;
      const msg = error.response?.data?.msg;

      if (
        !originalRequest ||
        originalRequest._retry ||
        status !== 401 ||
        msg !== "Token expired"
      ) {
        return Promise.reject(error);
      }

      if (!localStorage.getItem("refreshToken")) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      try {
        const { accessToken } = await rotateRefreshToken();
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return axios(originalRequest);
      } catch (refreshErr) {
        return Promise.reject(refreshErr);
      }
    },
  );
}

setupAxiosAuthInterceptor();
